document.addEventListener('DOMContentLoaded', () => {
  const scriptTag = document.getElementById('wkz-tracking-script');

  const cartUpdateUrl = scriptTag.dataset.cartUpdateUrl;

  if (!cartUpdateUrl) {
    console.error('WKZ Tracking Error: The cart update URL is missing.');
    return;
  }

  // Function to set a cookie
  function setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
  }

  function getCookie(name) {
    const cookieArr = document.cookie.split(';');
    for (let i = 0; i < cookieArr.length; i++) {
      const cookie = cookieArr[i].trim();
      if (cookie.indexOf(`${name}=`) === 0) {
        return cookie.substring(name.length + 1, cookie.length);
      }
    }
    return null;
  }

  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }

  const urlParams = new URLSearchParams(window.location.search);
  const currentHost = window.location.host;

  if (!getCookie('host')) {
    setCookie('host', currentHost);
  }

  const attributes = { host: currentHost };

  if (urlParams.has('wkz')) {
    // Ad platforms sometimes incorrectly encode additional params within the wkz value using & (%26) or spaces (+).
    // Splitting on the first & or space ensures only the actual WKZ code is captured.
    const wkz = urlParams.get('wkz').split(/[& ]/)[0];
    attributes.wkz = wkz;
    setCookie('wkz', wkz, 7);
  }

  const body = JSON.stringify({ attributes });

  fetch(cartUpdateUrl, { ...fetchConfig(), ...{ body } });
});
